export default __webpack_public_path__ + "static/media/Animals2_21.19ab5261.png";